import httpClient from '../../../api/httpClient';
import { DoctorScheduleRequestDto, DoctorScheduleResponseDto } from '../types/doctor-schedule.types';

const ENDPOINT = 'doctor-schedule';

/**
 * Doctor Schedule API service
 * Follows the same pattern as other API services in the project
 */
export const doctorScheduleApi = {
  /**
   * Get doctor's schedule for a specific date
   */
  getDoctorSchedule: async (params: DoctorScheduleRequestDto): Promise<DoctorScheduleResponseDto> => {
    const response = await httpClient.get<DoctorScheduleResponseDto>(ENDPOINT, { params });
    return response.data;
  },

  /**
   * Get available time slots for a doctor on a specific date
   * This is a convenience method that filters the schedule to only return available slots
   */
  getAvailableSlots: async (params: DoctorScheduleRequestDto): Promise<string[]> => {
    const schedule = await doctorScheduleApi.getDoctorSchedule(params);
    return schedule.slots
      .filter(slot => slot.available)
      .map(slot => slot.time);
  },

  /**
   * Check if a specific time slot is available
   */
  isSlotAvailable: async (params: DoctorScheduleRequestDto & { time: string }): Promise<boolean> => {
    const schedule = await doctorScheduleApi.getDoctorSchedule(params);
    const slot = schedule.slots.find(s => s.time === params.time);
    return slot ? slot.available : false;
  }
};
